import { LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  subtitle: string;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ 
  icon: Icon, 
  title, 
  subtitle, 
  className = "" 
}) => {
  return (
    <div className={`flex flex-col items-center justify-center py-12 space-y-4 ${className}`}>
      {/* Bolinha com ícone */}
      <div className="w-16 h-16 bg-gray-100 dark:bg-gray-800 rounded-full flex items-center justify-center">
        <Icon className="w-8 h-8 text-gray-400" />
      </div>
      
      {/* Título */}
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white text-center">
        {title}
      </h3>
      
      {/* Subtítulo */}
      <p className="text-sm text-gray-500 dark:text-gray-400 text-center max-w-sm">
        {subtitle}
      </p>
    </div>
  );
};









